<template>
    <div class="integralActivitylStore" ref="integralActivitylStore">
        <div>
            <div class="orderSearchBox">
                <div class="searchItem">
                    <!--<el-input v-model="form.activityName" placeholder="活动名称"></el-input>-->
                    <el-select clearable
                               v-model="form.activityUuid" placeholder="活动名称">
                        <el-option
                            v-for="item in activityList"
                            :key="item.uuid"
                            :label="item.activityName"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </div>
                <div class="searchItem">
                    <el-input v-model="form.storeName" placeholder="店铺名称"></el-input>
                </div>
                <div class="searchItem">
                    <el-input v-model="form.username" placeholder="账号"></el-input>
                </div>
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="resetData">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <!-- 排序 -->
            <div class="sorting">
        <span
        >已选： <span class="num">{{ num }}</span></span
        >
                <el-button type="primary" plain size="small" @click="publishSubmit"
                >批量导出
                </el-button
                >
            </div>
            <div class="orderListTable">
                <el-table
                    :data="tableData"
                    border
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    class="tableContent"
                >
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column
                        prop="activityName"
                        label="活动名称"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="storeName"
                        label="店铺名称"
                        header-align="center"
                        show-overflow-tooltip
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="username"
                        align="center"
                        header-align="center"
                        label="账号"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="contact"
                        align="center"
                        header-align="center"
                        label="联系人"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="contactTel"
                        align="center"
                        header-align="center"
                        label="联系电话"
                    >
                    </el-table-column>
                </el-table>
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total"
                    class="pagination"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        uploadFile,
        activitiesListByPage,
        activitiesList,
        getActivitiesDetails,
        saveActivities,
        publishActivities,
        delActivities,
        activitiesStoreListByPage,
        activitiesStoreList,
        activitiesGoodsListByPage,
        activitiesGoodsList,
        getActivitiesGoodsDetails,
        auditActivitiesGoods,
        activitiesStorePointListByPage,
        activitiesStorePointList,
        exchangeActivitiesStore
    } from "../../utils/interface";
    export default {
        name: "integralActivitylStore",
        data() {
            return {
                num: 0,
                multipleSelection: [],
                tableData: [
                ],
                current: 1,
                pageSize: 10,
                total: 0,
                form: {
                    activityUuid: "",
                    activityName: "",
                    storeName: "",
                    username: "",
                },
                activityList: [],
            };
        },
        mounted() {
            this.getActivityList();
        },
        methods: {
            getActivityList() {
                activitiesList({activityType: "INTEGRAL"}).then((res) => {
                    if (res.success) {
                        this.activityList = res.data;
                        if(this.$route.params.data){
                            this.form.activityUuid = this.$route.params.data.uuid;
                        }
                        this.search();
                    }
                });
            },
            search() {
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                this.form.activityType = "INTEGRAL";
                activitiesStoreListByPage(this.form).then((res)=>{
                    if(res.success) {
                        this.tableData = [];
                        this.total = res.data.total;
                        this.tableData = res.data.list
                    }
                });
            },
            resetData() {
                this.form.activityUuid = "";
                this.form.storeName = "";
                this.form.username = "";
                this.search()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.num = this.multipleSelection.length;
            },
            publishSubmit() {
                if(this.num==0){
                    this.$message.error("请选择要导出的数据");
                    return
                }
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../../static/js/Export2Excel');//注意这个Export2Excel路径
                    const tHeader = ['活动名称', '店铺名称', '账号', '联系人', '联系电话'];   // 上面设置Excel的表格第一行的标题
                    const filterVal = ['activityName', 'storeName', 'username', 'contact', 'contactTel']; // 上面的index、nickName、name是tableData里对象的属性key值
                    const list = this.multipleSelection;  //把要导出的数据tableData存到list
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '积分活动店铺管理');//最后一个是表名字
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            handleCurrentChange(val) {
                this.current = val
                this.search();
            },
        },
    };
</script>

<style lang="less" scoped>
    .integralActivitylStore {
        background: #fff;
        margin: 0 20px 20px;
        padding: 20px;

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;
            margin-bottom: 20px;

            /deep/ .el-input {
                width: initial;
                // margin-bottom: 22px;
                margin-right: 30px;
            }

            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover,
                &:focus {
                    background-color: #fff;
                    border: 1px solid #108ee9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #ffffff;
            }

            .resetBtn {
                color: #333333;
            }

            .searchItem {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .name {
                    padding-right: 20px;
                    min-width: 100px;
                }
            }

            .searchItem_time {
                margin-right: 20px;

                /deep/ .el-input__inner {
                    width: 292px;
                }
            }
        }

        .tableContent {
            min-height: 650px;

            /deep/ .el-table__header {
                tr {
                    th {
                        border-right: none;
                    }
                }

                /deep/ .el-table__cell {
                    padding: 5px 0;
                    background: #f2f5fc;
                }
            }

            /deep/ .el-table__body {
                img {
                    vertical-align: middle;
                    width: 52px;
                    height: 50px;
                }
            }
        }

        .pagination {
            margin-top: 20px;
            text-align: right;
        }

        .sorting {
            margin-bottom: 10px;
            font-size: 14px;

            span {
                margin-right: 15px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/integral/integralActivitylStore.vue